<template>

	<div class="image-text">
		<div class="text">
			<h4 v-if="!!$slots.subHeadline"><slot name="subHeadline" /></h4>
			<h2 v-if="!!$slots.headline"><slot name="headline" /></h2>
			<slot name="entrys" />
			<slot name="cta" />
		</div>
		<div class="image">
			<slot name="image" />
			<slot name="action" />
		</div>
	</div>

</template>

<script>

	export default {
		name: "ImageTextCta"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "button-reset.scss";
	@import "container.scss";
	@import "responsive-font.scss";

	.reversed {
		&.image-text {
			flex-direction:row-reverse;
			.text {
				@include media(large) {
					padding-left:2rem;
				}
				@include media(xxlarge) {
					padding-left:7rem;
				}
			}
			.image {
				@include media(small, large) {
					margin-top:2rem;
				}
				img {
					margin-right:auto;
				}
			}
		}
	}

	.image-text {
		@include container;
		position:relative; margin:5vw 0;
		@include media(large) {
			display:flex; justify-content:space-between; align-items:center;
		}
		& + .image-text {
			margin:10vw 0;
			@include media(xxlarge) {
				margin:14rem 0 0 0;
			}
		}
		&.bottom {
			margin-bottom:0;
			.image {
				align-self:flex-end;
				img {
					margin-bottom:-70vw;
					@include media(small, large) {
						margin-left:10vw;
					}
					@include media(large) {
						margin-bottom:-20vw;
					}
				}
			}
			.text {
				max-width:50%;
			}

		}
		&.image-full {
			margin-bottom:0;
			&:last-child {
				@include media(large) {
					margin-bottom:15rem;
				}
			}
			.image {
				margin-right:-5vw;
				@include media(small, large) {
					margin-left:-5vw;
				}
			}
			/deep/ {
				.image img {
					max-width:none;
				}
			}
		}
	}

	.image-center {
		margin-bottom:0;
		.text {
			display:none;
		}
		.image {
			width:100%; margin:0 auto -17vw;
		}
	}

	.image-overlap-bottom {
		&.image-text {
			margin-bottom:0;
		}
		.image {
			margin-bottom:-2rem;
		}
	}

	.text {
		z-index:9; flex:1 0 45%;
		// min-width:40rem;
		@include media(large) {
			padding-right:2rem;
		}
		@include media(xxlarge) {
			padding-right:7rem;
		}
		h2 {
			@include responsive-font(40);
			line-height:1.25; font-weight:400; color:#3D3D3D; margin-bottom:4rem; text-transform:uppercase;
		}
		h3 {
			@include responsive-font(20);
			color:#3D3D3D; font-weight:600; line-height:1.25; font-family:'proxima-nova'; margin-bottom:.8rem;
		}
		h4 {
			@include responsive-font(20);
			font-weight:400; line-height:1.33; text-transform:uppercase; color:#FDB913; margin-bottom:.8rem;
		}
		p {
			color:#6D6E71; margin:0;
			& + h3 {
				margin-top:2.4vw;
				@include media(xxlarge) {
					margin-top:3.2rem;
				}
			}
		}
		.btn {
			margin-top:2.4vw;
			@include media(xxlarge) {
				margin-top:3.2rem;
			}
		}
	}

	.image {
		@include responsive-font(10);
		z-index:1; position:relative; width:auto; flex:1 0 55%;
		@include media(small, large) {
			margin-top:2rem;
		}
		> img,
		> video {
			display:block; max-width:100%; width:100%; height:auto; margin:0 auto;
		}
		button {
			@include button-reset;
			position:absolute; top:0; left:0; width:100%; height:100%;
			img {
				position:absolute; cursor:pointer; transform:translate(-50%, -50%); top:50%; left:50%; width: 8em; height: 8em;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Products/ImageTextCta.vue